import React from 'react' 
import { ROUTE } from '../../route/Route'
import BreadCrumb from '../breadcrumb/BreadCrumb'
import SeoAdd from '../Seo/SeoAdd'

function DownloadReport() {
    return ( 
        <>
        <SeoAdd slug={ROUTE.DOWNLOADREPORT}/>
        <BreadCrumb page={"Download Report"} data={{slug: "", path: ""}}/>
        <section className="thank-section">
            <img className="scale" src="assets/img/prescription.png" alt="" />
            <div className="container">
                <div className="tab-content">
                    <div id="organs" className="tab-pane fade in active show">
                        <div className="row prescription-card">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <div className="h-services">
                                    <div className="infobox_wrapper">
                                        <div><img src="/assets/img/download_logo.png" className="mb-3" width="60" height="60" alt=""/></div>
                                        <h3 className="mr-10">Download Report</h3>
                                        <div className="ln-1 mr-10">Enter the details mentioned on your Recipt</div>
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-sm" placeholder="User Id" />
                                        </div>
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-sm" placeholder="Password" />
                                        </div>
                                        <button className="book--hexagon active"><span>Download Report<i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i></span></button> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
        </>
      )
  }
  
  export default DownloadReport